export default __webpack_public_path__ + "static/media/service-03.87fc374b.jpg";